import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, Clock, Star, ArrowLeft, Sparkles, Megaphone } from "lucide-react";
import LoginForm from "@/components/admin/LoginForm";
import HoursEditor from "@/components/admin/HoursEditor";
import ReviewsManager from "@/components/admin/ReviewsManager";
import AssistenteAI from "@/components/admin/AssistenteAI";
import AnnuncioEditor from "@/components/admin/AnnuncioEditor";
import logo from "@/assets/logo.png";

const TABS = [
  { id: "hours", label: "Orari", icon: Clock },
  { id: "reviews", label: "Recensioni", icon: Star },
  { id: "annuncio", label: "Annuncio", icon: Megaphone },
  { id: "ai", label: "Assistente AI", icon: Sparkles },
];

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem("imperiale_token"));
  const [tab, setTab] = useState("hours");

  if (!token) {
    return <LoginForm onSuccess={(t) => { localStorage.setItem("imperiale_token", t); setToken(t); }} />;
  }

  const logout = () => {
    localStorage.removeItem("imperiale_token");
    setToken(null);
  };

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-[#FDFBF7]">
      <header className="border-b border-bordeaux/15 bg-white">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4 px-5 py-4 sm:px-8">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Gelateria Imperiale" className="h-9 w-auto" />
            <span className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-stone-400">Area Gestore</span>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={`admin-tab-${t.id}`}
                onClick={() => setTab(t.id)}
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 font-mono-alt text-[11px] uppercase tracking-[0.18em] transition-colors ${
                  tab === t.id ? "bg-bordeaux text-ivory" : "text-stone-500 hover:bg-bordeaux/5"
                }`}
              >
                <t.icon className="h-4 w-4" /> {t.label}
              </button>
            ))}
            <button
              data-testid="admin-logout-button"
              onClick={logout}
              className="inline-flex items-center gap-2 rounded-full border border-bordeaux/25 px-5 py-2.5 font-mono-alt text-[11px] uppercase tracking-[0.18em] text-bordeaux transition-colors hover:bg-bordeaux hover:text-ivory"
            >
              <LogOut className="h-4 w-4" /> Esci
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-10 sm:px-8">
        {tab === "hours" && <HoursEditor />}
        {tab === "reviews" && <ReviewsManager />}
        {tab === "annuncio" && <AnnuncioEditor />}
        {tab === "ai" && <AssistenteAI />}
        <div className="mt-12">
          <Link
            data-testid="admin-back-to-site"
            to="/"
            className="inline-flex items-center gap-2 font-mono-alt text-[11px] uppercase tracking-[0.22em] text-stone-400 transition-colors hover:text-bordeaux"
          >
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </Link>
        </div>
      </main>
    </div>
  );
}
